import script from "./LocaleToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocaleToggle.vue?vue&type=script&setup=true&lang=ts"

import "./LocaleToggle.vue?vue&type=style&index=0&id=3b1d09af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1d09af"]])

export default __exports__